import React, { useState, useEffect } from 'react'
import { Row, Col, Form } from "react-bootstrap";
import "../../../../assets/css/cms/tools.css";
import { FieldArray } from "formik";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiFillMinusSquare } from "react-icons/ai";
import CustomEditor5 from "../../../../utils/ckEditor5";
import { TiDelete } from "react-icons/ti";
import Select from "react-select";
import { clearInputDetailResponse, clearPostInputDetailResponse, clearInputToolContentResponse } from "../../../../../store/slices/managePredictorTools";
import { getInputPageDetails, getBasicDetails, getInputPageFaqContent, getInputPageToolContent, getPredictorToolAuthor } from "../../../../../store/actions/cms/predictorTools";
export const toolContent = {
    id: "",
    heading: "",
    image_web: "",
    image_wap: "",
    content: "",
};
export const FAQs = { id: "", question: "", answer: "" };

const InputPageAddEdit = ({ values, activeStep, setFieldValue, errors, touched, setTouched,
    handleSubmit, productId, dispatch, handleBlur, preventTyping, handleChangeImage, setSaveNext,
    postInputToolContentData, postInputPageFaqData, postInputDetailData, basicDetailError, navigate, basicDetailData,
    predictorToolAuthorData,
}) => {
    const [debounceState, setDebounceState] = useState("");


    useEffect(() => {
        // for stepper
        dispatch(getBasicDetails({ "product_id": productId }))
        dispatch(getInputPageDetails({ "product_id": productId }))
        dispatch(getInputPageFaqContent({ "product_id": productId }))
        dispatch(getInputPageToolContent({ "product_id": productId }))
        dispatch(getPredictorToolAuthor({ field_name: "tools_author_name" }))
        return (() => {
            setSaveNext(false);
            dispatch(clearInputDetailResponse());
            dispatch(clearPostInputDetailResponse());
            dispatch(clearInputToolContentResponse());
        })
    }, [])

    // for stepper
    useEffect(() => {
        if (
            basicDetailError ||
            (basicDetailData &&
                basicDetailData?.basic_detail?.type !== undefined &&
                (basicDetailData?.basic_detail?.type === '' || basicDetailData?.basic_detail?.type === null))
        ) {
            window.location.href = `/cms/tools/manage-predictor/basic-form/${productId ? productId : ""}`;
        }
    }, [basicDetailError, basicDetailData]);


    useEffect(() => {
        dispatch(getInputPageDetails({ "product_id": productId }))
        dispatch(getInputPageFaqContent({ "product_id": productId }))
        dispatch(getInputPageToolContent({ "product_id": productId }))
    }, [productId])

    useEffect(() => {
        if (postInputToolContentData || postInputPageFaqData || postInputDetailData) {
            dispatch(getInputPageDetails({ "product_id": productId }))
            dispatch(getInputPageFaqContent({ "product_id": productId }))
            dispatch(getInputPageToolContent({ "product_id": productId }))

        }
    }, [postInputToolContentData, postInputPageFaqData, postInputDetailData])

    const handleOnInputChangeFields = (value) => {
        let inDebounce = debounceState;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => {
            dispatch(getPredictorToolAuthor({ field_name: "tools_author_name", q: value }))

        }, 1000);
        setDebounceState(inDebounce);
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* ******************INPUT PAGE CONTENT BLOCK ************** */}
            <div className={"examfilter  mb-4"}>
                <h5 className="mb-4">
                    <strong>Input Page Content</strong>
                </h5>
                <Row className="mb-4">
                    <Col md={1}>
                        <span>Set Tool's Name as: </span>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="radio"
                                id="dynamic_name"
                                name="display_name_type"
                                defaultValue={1}
                                checked={values?.display_name_type == 1}
                                value={1}
                                onChange={(e) =>
                                    setFieldValue("display_name_type", e.target.value)
                                }
                            ></Form.Check>
                            <Form.Label htmlFor="dynamic_name" className="mx-2">
                                {" "}
                                Custom Display Name/H1
                            </Form.Label>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group className="d-flex">
                            <Form.Check
                                type="radio"
                                id="custom_name"
                                name="display_name_type"
                                value={2}
                                checked={values?.display_name_type == 2}
                                onChange={(e) =>
                                    setFieldValue("display_name_type", e.target.value)
                                }
                            ></Form.Check>
                            <Form.Label htmlFor="custom_name" className="mx-2">
                                Enter Text for Tool’s Display Name/H1
                            </Form.Label>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    {values?.display_name_type == 1 &&
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Exam Name<sup className="icon_star">*</sup></Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={"input_pd"}
                                        name="custom_exam_name"
                                        value={values?.custom_exam_name || ""}    
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            value = value.replace(/^\s+/g, "");
                                            setFieldValue("custom_exam_name", value)
                                        }}
                                        onBlur={handleBlur}
                                        onKeyDown={(e) =>
                                            preventTyping(e, "custom_exam_name")
                                        }
                                    />
                                    {errors.custom_exam_name && touched.custom_exam_name && (
                                        <span className="error">
                                            {errors.custom_exam_name}
                                        </span>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tool’s Flow Type<sup className="icon_star">*</sup></Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={"input_pd"}
                                        name="custom_flow_type"
                                        value={values?.custom_flow_type || ""}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            value = value.replace(/^\s+/g, "");
                                            setFieldValue("custom_flow_type", value)
                                        }}
                                        onKeyDown={(e) =>
                                            preventTyping(e, "custom_flow_type")
                                        }
                                        onBlur={handleBlur}
                                    />
                                    {errors.custom_flow_type && touched.custom_flow_type && (
                                        <span className="error">
                                            {errors.custom_flow_type}
                                        </span>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Year<sup className="icon_star">*</sup></Form.Label>
                                    <Form.Control
                                        type="text"
                                        className={"input_pd"}
                                        name="custom_year"
                                        value={values?.custom_year || ""}
                                        onChange={(e) => {
                                            // Allow only numeric values
                                            const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                            setFieldValue("custom_year", numericValue);
                                        }}
                                        onKeyDown={(e) =>
                                            preventTyping(e, "custom_year")
                                        }
                                        onBlur={handleBlur}
                                    />
                                    {errors.custom_year && touched.custom_year && (
                                        <span className="error">
                                            {errors.custom_year}
                                        </span>
                                    )}
                                </Form.Group>
                            </Col>

                        </Row>
                    }
                    {values?.display_name_type == 2 &&
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Tool Title/Display Name/ H1<sup className="icon_star">*</sup></Form.Label>
                                <Form.Control
                                    type="text"
                                    className={"input_pd"}
                                    name="alias"
                                    value={values?.alias}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/^\s+/g, "");
                                        setFieldValue("alias", value)
                                    }}
                                    onBlur={handleBlur}
                                    onKeyDown={(e) =>
                                        preventTyping(e, "alias")
                                    }
                                />
                                {errors.alias && touched.alias && (
                                    <span className="error">
                                        {errors.alias}
                                    </span>
                                )}
                            </Form.Group>
                        </Col>
                    }

                    {(values?.custom_exam_name || values?.custom_flow_type || values?.custom_year) && values?.display_name_type == 1 &&
                        <span className="mb-4">
                            <b>Display Name :</b>{`${values?.custom_exam_name || ""}  ${values?.custom_flow_type || ""}  ${values?.custom_year ? "Predictor " + values?.custom_year : ""}`}
                        </span>}
                </Row>



                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                <strong>Tool Listing Description<sup className="icon_star">*</sup></strong>
                            </Form.Label>
                            {(values?.listing_desc ||
                                values?.listing_desc == undefined ||
                                values?.listing_desc === "" ||
                                values?.listing_desc === null) && (
                                    <div className='ck-editor-listing'>
                                        <CustomEditor5
                                            name={"listing_desc"}
                                            initData={values?.listing_desc == null ? "" : values?.listing_desc}
                                            config={{
                                                toolbar: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "blockQuote",
                                                    "|",
                                                    "insertTable",
                                                    "tableColumn",
                                                    "tableRow",
                                                    "mergeTableCells",
                                                    "|",
                                                    "undo",
                                                    "redo",
                                                    "imageUpload",
                                                ],
                                                embed_provider:
                                                    "https://iframe.ly/api/oembed?url={url}&callback={callback}&api_key=4a0bf889ea5702d2a09190",
                                                allowedContent: true,
                                            }}
                                            onChange={(data) =>
                                                setFieldValue("listing_desc", data)
                                            }
                                            onBlur={() => {
                                                setTouched({ ...touched, listing_desc: true })

                                            }}
                                        />
                                    </div>
                                )}
                            {errors?.listing_desc &&
                                touched?.listing_desc && (
                                    <div

                                        className="error"
                                    >
                                        {errors?.listing_desc}
                                    </div>
                                )}
                        </Form.Group>
                    </Col>
                </Row>
                <div className="examfilter mb-4">
                    <h5>
                        <strong>Header Section cards</strong>
                    </h5>
                    {/* {typeof errors?.header_section === "string" && touched?.header_section && (
                        <div className="error mb-3">{errors.header_section}</div>
                    )} */}
                    <FieldArray name="header_section">
                        {({ remove, push }) => (
                            <div className={""}>
                                {(Array.isArray(values?.header_section) && values.header_section.length > 0 ? values.header_section : [])?.map(
                                    (element, index) => (
                                        <Row>
                                            <Col md={10}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Description
                                                        <sup className="icon_star">*</sup>
                                                    </Form.Label>
                                                    <Form.Control
                                                        name={`header_section.${index}`}
                                                        as="textarea"
                                                        className={"input_pd"}
                                                        placeholder={`Card ${index + 1}`}
                                                        value={element}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/^\s+/g, "");
                                                            setFieldValue(`header_section.${index}`, value)
                                                        }}
                                                        maxLength={201}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors?.header_section?.[index] && touched?.header_section?.[index] && (
                                                        <div className="error">
                                                            {errors.header_section[index]}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col
                                                md={1}
                                                className="bottom_right_button_container"
                                            >
                                                <div className={"imageField_fieldArray"}>
                                                    <div className={"imageField_add"}>
                                                        {values.header_section &&
                                                            values.header_section?.length > 1 && (
                                                                <span
                                                                    className={
                                                                        "imageField_minus_icon"
                                                                    }
                                                                >
                                                                    <AiFillMinusSquare
                                                                        onClick={() => {
                                                                            if (
                                                                                window.confirm(
                                                                                    "Are you sure you want to remove this  Header Section Description?"
                                                                                )
                                                                            ) {
                                                                                // props.dispatch(deleteCmsWebinarUrl(element?.id));
                                                                                remove(index);
                                                                            }
                                                                        }}
                                                                    />
                                                                </span>
                                                            )}
                                                    </div>
                                                    <div>
                                                        {index ==
                                                            values.header_section?.length - 1 && (
                                                                <button
                                                                    className={"imageField_add_icon"}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        push("");
                                                                    }}
                                                                    type="submit"
                                                                    // to avoid empty inputs submission
                                                                    disabled={!values?.header_section?.[index]?.length>=1}
                                                                >
                                                                    <BsFillPlusSquareFill />
                                                                </button>
                                                            )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    )
                                )}
                            </div>
                        )}
                    </FieldArray>
                </div>
                <div className="examfilter mb-4">
                    <h5 className="mb-2">
                        <strong>Tool's Content</strong>
                    </h5>
                    <FieldArray name="data">
                        {({ remove, push }) => (
                            <div className={"margin_bottom"}>
                                {[...(values?.data || [])]?.map(
                                    (element, index) => (
                                        <div className="mt-4">
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>  Heading/ H2
                                                            {/* Heading {index > 0 && index + 1} */}
                                                            {(values?.data?.[index]?.heading || values?.data?.[index]?.content || values?.data?.[index]?.image_web || values?.data?.[index]?.image_wap) ?
                                                                <sup className="icon_star">*</sup> : ""}</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className={"input_pd"}
                                                            name={`data.${index}.heading`}
                                                            placeholder={`Enter Heading ${index + 1
                                                                }`}
                                                            value={
                                                                values?.data?.[index]
                                                                    ?.heading
                                                            }
                                                            onChange={(e) => {
                                                                let value = e.target.value;
                                                                value = value.replace(/^\s+/g, "");
                                                                setFieldValue(`data.${index}.heading`, value)
                                                            }}
                                                            onBlur={handleBlur}
                                                            maxLength={50} // Char limit
                                                        />
                                                        {errors.data?.[index]?.heading &&
                                                            touched.data?.[index]?.heading && (
                                                                <div className="error">{errors.data[index].heading}</div>
                                                            )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">
                                                            Image/GIF(Web){" "}
                                                            {(values?.data?.[index]?.heading || values?.data?.[index]?.content || values?.data?.[index]?.image_web || values?.data?.[index]?.image_wap) ? <sup className="icon_star">*</sup> : ""}</Form.Label>

                                                        <input
                                                            name={`data.${index}.image_web`}
                                                            type="file"
                                                            accept=".jpg,.png,.gif,.jpeg"
                                                            className="mb-2"
                                                            onChange={(e) =>
                                                                handleChangeImage(
                                                                    e,
                                                                    `data.${index}.image_web`
                                                                )
                                                            }
                                                            onBlur={handleBlur}

                                                        />

                                                        {typeof values.data?.[index]?.image_web == "string" && values.data?.[index]?.image_web != "" ?
                                                            <div className="media_image_container mt-2">
                                                                <a href={values.data?.[index]?.image_web} target="_blank">
                                                                    {values.data?.[index]?.image_web}
                                                                </a>
                                                                <span className={"delete_image_btn mt-1"} onClick={() => {
                                                                    setFieldValue(`data.${index}.image_web`, "")
                                                                }}>
                                                                    <TiDelete />
                                                                </span>
                                                            </div>
                                                            : ""}
                                                        {errors.data?.[index]?.image_web &&
                                                            touched.data?.[index]?.image_web && (
                                                                <div className="error">{errors.data[index].image_web}</div>
                                                            )}

                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="d-block">
                                                            Image/GIF Mob
                                                            {(values?.data?.[index]?.heading || values?.data?.[index]?.content || values?.data?.[index]?.image_web || values?.data?.[index]?.image_wap) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                                                        <input
                                                            name={`data.${index}.image_wap`}
                                                            type="file"
                                                            accept=".jpg,.png,.gif,.jpeg"
                                                            className="mb-2"
                                                            onChange={(e) =>
                                                                handleChangeImage(
                                                                    e,
                                                                    `data.${index}.image_wap`
                                                                )
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                        {typeof values?.data?.[index]?.image_wap == "string" && values?.data?.[index]?.image_wap != "" ?
                                                            <div className="media_image_container mt-2">
                                                                <a href={values?.data?.[index]?.image_wap} target="_blank">
                                                                    {values?.data?.[index]?.image_wap}
                                                                </a>
                                                                <span className={"delete_image_btn mt-1"} onClick={() => {
                                                                    setFieldValue(`data.${index}.image_wap`, "")
                                                                }}>
                                                                    <TiDelete />
                                                                </span>
                                                            </div>
                                                            : ""}
                                                        {errors.data?.[index]?.image_wap &&
                                                            touched.data?.[index]?.image_wap && (
                                                                <div className="error">{errors.data[index].image_wap}</div>
                                                            )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={10}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Description
                                                            {(values?.data?.[index]?.heading || values?.data?.[index]?.content || values?.data?.[index]?.image_web || values?.data?.[index]?.image_wap) ? <sup className="icon_star">*</sup> : ""}</Form.Label>

                                                        {(values?.data?.[index]
                                                            ?.content ||
                                                            values?.data?.[index]
                                                                ?.content == undefined ||
                                                            values?.data?.[index]
                                                                ?.content === "" ||
                                                            values?.data?.[index]
                                                                ?.content === null) && (
                                                                <>
                                                                    <CustomEditor5
                                                                        name={`data.${index}.content`}
                                                                        initData={values?.data?.[index]
                                                                            ?.content == null ? "" : values?.data?.[index]
                                                                            ?.content}

                                                                        config={{
                                                                            toolbar: [
                                                                                "heading",
                                                                                "|",
                                                                                "bold",
                                                                                "italic",
                                                                                "link",
                                                                                "bulletedList",
                                                                                "numberedList",
                                                                                "blockQuote",
                                                                                "|",
                                                                                "insertTable",
                                                                                "tableColumn",
                                                                                "tableRow",
                                                                                "mergeTableCells",
                                                                                "|",
                                                                                "undo",
                                                                                "redo",
                                                                                "imageUpload",
                                                                            ],
                                                                            embed_provider:
                                                                                "https://iframe.ly/api/oembed?url={url}&callback={callback}&api_key=4a0bf889ea5702d2a09190",
                                                                            allowedContent: true,
                                                                        }}
                                                                        onChange={(data) => {
                                                                            setFieldValue(
                                                                                `data.${index}.content`,
                                                                                data
                                                                            );
                                                                        }}
                                                                        onBlur={() => {
                                                                            if (touched.data?.[index]) {
                                                                                setTouched({
                                                                                    ...touched,
                                                                                    data: touched.data?.map((item, i) =>
                                                                                        i === index ? { ...item, content: true } : item
                                                                                    ),
                                                                                });
                                                                            }
                                                                        }}
                                                                    />
                                                                </>
                                                            )}
                                                        {errors.data?.[index]?.content &&
                                                            touched.data?.[index]?.content && (
                                                                <div className="error">{errors.data[index].content}</div>
                                                            )}
                                                    </Form.Group>
                                                </Col>
                                                <Col
                                                    md={1}
                                                    className="bottom_right_button_container"
                                                >
                                                    <div className={"imageField_fieldArray"}>
                                                        <div className={"imageField_add"}>
                                                            {values?.data &&
                                                                values?.data?.length > 1 && (
                                                                    <span
                                                                        className={
                                                                            "imageField_minus_icon"
                                                                        }
                                                                    >
                                                                        <AiFillMinusSquare
                                                                            onClick={() => {
                                                                                if (
                                                                                    window.confirm(
                                                                                        "Are you sure you want to remove this Tool Content Details?"
                                                                                    )
                                                                                ) {
                                                                                    remove(index);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </span>
                                                                )}
                                                        </div>
                                                        <div>
                                                            {index ==
                                                                values?.data?.length - 1 && (
                                                                    <button
                                                                        className={"imageField_add_icon"}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            push(toolContent);
                                                                        }}
                                                                        type="submit"
                                                                    >
                                                                        <BsFillPlusSquareFill />
                                                                    </button>
                                                                )}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    )
                                )}

                            </div>

                        )}
                    </FieldArray>
                </div>

                <div className="examfilter mb-4">
                    <h5 className="mb-4">
                        <strong>Tool's FAQs</strong>
                    </h5>
                    <FieldArray name="response">
                        {({ remove, push }) => (
                            <div className="margin_bottom">
                                {(Array.isArray(values?.response) && values.response?.length > 0 ? values?.response : [])?.map((element, index) => (
                                    <div className="mb-2" key={index}>
                                        <Row>
                                            <Col md={10}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Question
                                                        {(values?.response?.[index]?.question || values?.response?.[index]?.answer) ?
                                                            <sup className="icon_star">*</sup> : ""}</Form.Label>

                                                    <Form.Control
                                                        name={`response.${index}.question`}
                                                        type="text"
                                                        className={"input_pd"}
                                                        placeholder="Enter Question"
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/^\s+/g, "");
                                                            setFieldValue(`response.${index}.question`, value)
                                                        }}
                                                        maxLength={201}
                                                        value={element?.question}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors?.response?.[index]?.question &&
                                                        touched?.response?.[index]?.question && (
                                                            <div className="error">
                                                                {errors.response[index].question}
                                                            </div>
                                                        )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={10}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Answer
                                                        {(values?.response?.[index]?.question || values?.response?.[index]?.answer) ?
                                                            <sup className="icon_star">*</sup> : ""}</Form.Label>

                                                    {(values?.response?.[index]?.answer ||
                                                        values?.response?.[index]?.answer ==
                                                        undefined ||
                                                        values?.response?.[index]?.answer === "" ||
                                                        values?.response?.[index]?.answer ===
                                                        null) && (
                                                            <div className='ck-editor-listing'>
                                                                <CustomEditor5
                                                                    name={`response.${index}.answer`}
                                                                    // initData={values?.response?.[index].answer}
                                                                    initData={values?.response?.[index]?.answer
                                                                        == null ? "" : values?.response?.[index]?.answer}
                                                                    config={{
                                                                        toolbar: [
                                                                            "heading",
                                                                            "|",
                                                                            "bold",
                                                                            "italic",
                                                                            "link",
                                                                            "bulletedList",
                                                                            "numberedList",
                                                                            "blockQuote",
                                                                            "|",
                                                                            "insertTable",
                                                                            "tableColumn",
                                                                            "tableRow",
                                                                            "mergeTableCells",
                                                                            "|",
                                                                            "undo",
                                                                            "redo",
                                                                            "imageUpload",
                                                                        ],
                                                                        embed_provider:
                                                                            "https://iframe.ly/api/oembed?url={url}&callback={callback}&api_key=4a0bf889ea5702d2a09190",
                                                                        allowedContent: true,
                                                                    }}
                                                                    onChange={(data) => {
                                                                        setFieldValue(`response.${index}.answer`, data);
                                                                    }}
                                                                    onBlur={() => {
                                                                        if (touched?.response?.[index]) {
                                                                            setTouched({
                                                                                ...touched,
                                                                                response: touched.response?.map((item, i) =>
                                                                                    i === index ? { ...item, answer: true } : item
                                                                                ),
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        )}

                                                    {errors?.response?.[index]?.answer &&
                                                        touched?.response?.[index]?.answer && (
                                                            <div className="error">
                                                                {errors.response[index]?.answer}
                                                            </div>
                                                        )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={1} className="bottom_right_button_container">
                                                <div className="imageField_fieldArray">
                                                    <div className="imageField_add">
                                                        {values.response && values.response?.length > 1 && (
                                                            <span
                                                                className={"imageField_minus_icon"}
                                                                onClick={() => {
                                                                    if (
                                                                        window.confirm(
                                                                            "Are you sure you want to remove this FAQs Details?"
                                                                        )
                                                                    ) {
                                                                        remove(index);
                                                                    }
                                                                }}
                                                            >
                                                                <AiFillMinusSquare />
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {index === values.response?.length - 1 && (
                                                            <button
                                                                className="imageField_add_icon"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    push(FAQs);
                                                                }}
                                                                type="submit"
                                                            >
                                                                <BsFillPlusSquareFill />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </div>
                        )}
                    </FieldArray>

                </div>

                <div className="examfilter mb-4">
                    <Row>
                        <Form.Label>
                            <h5><strong>Other Exam Related Content</strong></h5>
                        </Form.Label>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Author{(values?.exam_other_content || values?.exam_content_author) && <sup className="icon_star">*</sup>}{" "}
                                </Form.Label>
                                <Select
                                    name="exam_content_author"
                                    options={predictorToolAuthorData?.tools_author_name}
                                    getOptionLabel={(option) => option.value}
                                    getOptionValue={(option) => option.id}
                                    value={values?.exam_content_author}
                                    onChange={(data) =>
                                        setFieldValue("exam_content_author", data)
                                    }
                                    onInputChange={(value) => {
                                        handleOnInputChangeFields(value);
                                    }}
                                    onBlur={() => {
                                        setTouched({
                                            ...touched,
                                            exam_content_author: true
                                        });
                                    }}
                                    isClearable={true}
                                    isSearchable={true}
                                    placeholder={"Search by Author"}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                                {errors.exam_content_author && touched.exam_content_author && (
                                    <span className="error">{errors.exam_content_author}</span>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Other Exam related content{(values?.exam_other_content || values?.exam_content_author) && <sup className="icon_star">*</sup>}{" "}
                                </Form.Label>
                                {(values?.exam_other_content ||
                                    values?.exam_other_content == undefined ||
                                    values?.exam_other_content === "" ||
                                    values?.exam_other_content === null) && (
                                        <div className='ck-editor-content'>
                                            <CustomEditor5
                                                name={"exam_other_content"}
                                                initData={values?.exam_other_content == null ? "" : values?.exam_other_content}
                                                config={{
                                                    toolbar: [
                                                        "heading",
                                                        "|",
                                                        "bold",
                                                        "italic",
                                                        "link",
                                                        "bulletedList",
                                                        "numberedList",
                                                        "blockQuote",
                                                        "|",
                                                        "insertTable",
                                                        "tableColumn",
                                                        "tableRow",
                                                        "mergeTableCells",
                                                        "|",
                                                        "undo",
                                                        "redo",
                                                        "imageUpload",
                                                    ],
                                                    embed_provider:
                                                        "https://iframe.ly/api/oembed?url={url}&callback={callback}&api_key=4a0bf889ea5702d2a09190",
                                                    allowedContent: true,
                                                }}
                                                onChange={(data) =>
                                                    setFieldValue(
                                                        "exam_other_content",
                                                        data
                                                    )
                                                }
                                                onBlur={() => {
                                                    setTouched({
                                                        ...touched,
                                                        exam_other_content: true
                                                    });
                                                }}
                                            />
                                        </div>
                                    )}
                                {errors?.exam_other_content &&
                                    touched?.exam_other_content && (
                                        <div className="error">
                                            {errors.exam_other_content}
                                        </div>
                                    )}
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>
            {/* ****************SAVE AND CANCEL BUTTONS***************** */}
            <div className={"my-5 d-flex justify-content-start"}>
                <button
                    className={"exam_button"}
                    type="submit"
                >
                    Save
                </button>
                {activeStep < 2 && (
                    <button
                        className="btnInfo"
                        type="submit"
                        onClick={() => {
                            setSaveNext(true);
                        }}
                        onBlur={() => {
                            setSaveNext(false);
                            // dispatch(clearPostBasicDetailResponse());
                            handleSubmit(); // Manually trigger the form submission
                        }}
                    >
                        Save & Next
                    </button>
                )}

            </div>
        </form>
    )
}

export default InputPageAddEdit